var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fz-12 font-h6-regular text-color"},[_vm._v("订单量："+_vm._s(_vm._f("formatPrice2")(_vm._f("formatEmpty")(_vm.row.orderNum))))]),_c('div',{staticClass:"fz-12 font-h6-regular text-color"},[_vm._v("销售额："+_vm._s(_vm._f("formatPrice2")(_vm._f("formatEmpty")(_vm.row.totalAmount))))])])
}
var staticRenderFns = []

export { render, staticRenderFns }